import React, { useEffect } from 'react';
import './Returnpolicy.css';
import '../PolicyPages.css';

function Returnpolicy() {
    useEffect(() => { window.scrollTo(0, 0); }, []);

    return (
        <div className="policy-page">

            {/* Hero */}
            <div className="policy-hero">
                <div className="container">
                    <div className="policy-hero-icon"><i className="fas fa-undo-alt"></i></div>
                    <h1 className="policy-hero-title">Return, Refund &amp; Exchange Policy</h1>
                    <p className="policy-hero-sub">Last updated: June 2025</p>
                </div>
            </div>

            {/* Card */}
            <div className="container">
                <div className="policy-card">

                    <p className="policy-intro">
                        At <strong>PENTADECO</strong>, we strive to ensure that you are fully satisfied with every purchase.
                        However, if you are not completely happy with your order, our Return, Refund &amp; Exchange Policy is
                        designed to help you shop with confidence.
                    </p>

                    <div className="policy-section">
                        <div className="policy-section-header">
                            <span className="policy-num">1</span>
                            <h3 className="policy-section-title">Eligibility for Returns &amp; Exchanges</h3>
                        </div>
                        <ul className="policy-list">
                            <li><strong>Condition:</strong> Products must be unused, unworn, and returned in original packaging with all tags, labels, and accessories intact.</li>
                            <li><strong>Non-returnable items:</strong> Personalized/customized products, clearance or sale items marked "Final Sale," and opened/used personal accessories (for hygiene reasons).</li>
                        </ul>
                    </div>

                    <div className="policy-section">
                        <div className="policy-section-header">
                            <span className="policy-num">2</span>
                            <h3 className="policy-section-title">Return Window</h3>
                        </div>
                        <p className="policy-text">
                            Returns/exchanges must be requested <strong>within 7 days of delivery</strong>.
                            Requests made after this period may not be accepted.
                        </p>
                    </div>

                    <div className="policy-section">
                        <div className="policy-section-header">
                            <span className="policy-num">3</span>
                            <h3 className="policy-section-title">Return Process</h3>
                        </div>
                        <ul className="policy-list">
                            <li><strong>Initiate:</strong> Contact our support team via email or WhatsApp with your order number, reason for return, and photo/video proof (if defective/damaged).</li>
                            <li><strong>Return Shipping — Defect/Wrong item:</strong> We bear the shipping cost.</li>
                            <li><strong>Return Shipping — Personal preference:</strong> Customer bears the shipping cost.</li>
                        </ul>
                    </div>

                    <div className="policy-section">
                        <div className="policy-section-header">
                            <span className="policy-num">4</span>
                            <h3 className="policy-section-title">Refunds</h3>
                        </div>
                        <ul className="policy-list">
                            <li><strong>Processing Time:</strong> Refunds are processed within <strong>7–10 working days</strong> after inspection and approval.</li>
                            <li><strong>Method:</strong> Refunds will be credited to the original payment method or as store credit.</li>
                            <li><strong>Original Shipping:</strong> Non-refundable unless return is due to our error/defective product.</li>
                        </ul>
                    </div>

                    <div className="policy-section">
                        <div className="policy-section-header">
                            <span className="policy-num">5</span>
                            <h3 className="policy-section-title">Exchanges</h3>
                        </div>
                        <p className="policy-text">
                            Exchanges are available for defective/damaged products or size variations (if applicable).
                            If the replacement is out of stock, you may choose a refund or a different product of equal value.
                        </p>
                    </div>

                    <div className="policy-section">
                        <div className="policy-section-header">
                            <span className="policy-num">6</span>
                            <h3 className="policy-section-title">Damaged, Defective or Incorrect Items</h3>
                        </div>
                        <p className="policy-text">
                            If you receive a defective or incorrect product, notify us within <strong>48 hours of delivery</strong> with
                            order details and proof. We will arrange free pickup and replacement/refund.
                        </p>
                    </div>

                    <div className="policy-section">
                        <div className="policy-section-header">
                            <span className="policy-num">7</span>
                            <h3 className="policy-section-title">Order Cancellations</h3>
                        </div>
                        <p className="policy-text">
                            Orders can be cancelled <strong>before dispatch</strong>. Once dispatched, cancellations are not allowed.
                            You may still return after delivery as per this policy.
                        </p>
                    </div>

                    {/* Contact */}
                    <div className="policy-contact-card">
                        <p className="policy-contact-title"><i className="fas fa-headset"></i> Contact Us</p>
                        <div className="policy-contact-row">
                            <i className="fas fa-building"></i>
                            <span>PENTADECO Customer Care</span>
                        </div>
                        <div className="policy-contact-row">
                            <i className="fas fa-envelope"></i>
                            <span><a href="mailto:pentadeco@gmail.com">pentadeco@gmail.com</a></span>
                        </div>
                        <div className="policy-contact-row">
                            <i className="fab fa-whatsapp"></i>
                            <span>
                                <a href="tel:+917738494171">+91 77384 94171</a> &nbsp;|&nbsp;
                                <a href="tel:+918433551012">+91 84335 51012</a> &nbsp;|&nbsp;
                                <a href="tel:+919273158535">+91 92731 58535</a>
                            </span>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default Returnpolicy;
